import { z } from "zod/v4";

export const PLANNING_VIEWS = ["day", "week"] as const;

/** Mijn lesdag and Mijn lesweek: whose lessen show besides the docent's own. */
export const docentenSearchSchema = z.object({
  /** The colleagues (schooldocentIds) whose lessen show too. */
  docenten: z.array(z.string()).catch([]).default([]),
});

export const DOCENTEN_SEARCH_DEFAULTS: z.infer<typeof docentenSearchSchema> = {
  docenten: [],
};

export const lesdagSearchSchema = docentenSearchSchema.extend({
  /** The day shown (YYYY-MM-DD); null means today. */
  date: z.string().nullable().catch(null).default(null),
});

export const LESDAG_SEARCH_DEFAULTS = {
  ...DOCENTEN_SEARCH_DEFAULTS,
  date: null,
};

export const planningSearchSchema = docentenSearchSchema.extend({
  /** Selected day (YYYY-MM-DD); null means today. */
  date: z.string().nullable().catch(null).default(null),
  /** null picks the view by screen size: dag on mobile, week elsewhere. */
  view: z.enum(PLANNING_VIEWS).nullable().catch(null).default(null),
});

export const PLANNING_SEARCH_DEFAULTS = {
  ...DOCENTEN_SEARCH_DEFAULTS,
  date: null,
  view: null,
};

/** A schooldag, 1 = maandag … 5 = vrijdag, as the backend numbers them. */
export const weekdagSchema = z.number().int().min(1).max(5);

export const roosterSearchSchema = z.object({
  /** The weekdag the rooster shows; null is today's, or maandag at the weekend. */
  weekdag: weekdagSchema.nullable().catch(null).default(null),
});

export const ROOSTER_SEARCH_DEFAULTS = {
  weekdag: null,
};

/** The vakanties dialog opens over the rooster page; Mijn lesdag opens it too. */
export const jaarplanningSearchSchema = z.object({
  /** The week to open on, highlighted. */
  week: z.string().optional(),
  /** Only the weeks that are not fully planned yet. */
  unplanned: z.boolean().catch(false).default(false),
});

export const JAARPLANNING_SEARCH_DEFAULTS = {
  unplanned: false,
};

export type PlanningView = (typeof PLANNING_VIEWS)[number];
